import { Component, HostBinding, Input } from '@angular/core';
import { ThemeProviderService } from 'src/app/shared/services/theme-provider.service';
import { LinkTarget } from 'src/app/shared/types/link-target.type';

@Component({
  selector: 'studio-popup-menu-item',
  templateUrl: './popup-menu-item.component.html',
  styleUrls: ['./popup-menu-item.component.scss'],
})
export class PopupMenuItemComponent {
  @Input() text: string;
  @Input() description: string;
  @Input() href: string;
  @Input() target: LinkTarget = '_blank';
  @Input() disabled = false;

  @HostBinding('class')
  protected get theme() {
    return this.themeProviderService.getTheme();
  }

  constructor(private themeProviderService: ThemeProviderService) {}

  // This handler is bound to the click event of the <li> which occupies the entire component area
  // it allows us to intercept any click on the component and stop its propagation when disabled
  protected itemClicked(e: Event) {
    if (this.disabled) {
      e.stopPropagation();
    }
  }
}
